import { render, staticRenderFns } from "./configItemData.vue?vue&type=template&id=a9b96124&scoped=true&"
import script from "./configItemData.vue?vue&type=script&lang=js&"
export * from "./configItemData.vue?vue&type=script&lang=js&"
import style0 from "./configItemData.vue?vue&type=style&index=0&id=a9b96124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b96124",
  null
  
)

export default component.exports